import {
	FlexButton,
	MimaButton,
	MimaInput,
	MimaText,
	MimaTextArea,
	Modal,
} from '../../components';
import styles from '../../assets/styles/Settings/Settings.module.scss';
import Support from '../../assets/img/MimaSupport.png';
import Sent from '../../assets/img/Mima msg-sent.png';
import { IoIosArrowForward } from 'react-icons/io';
import { supportStore } from '../../stores';
import { IoMdCall } from 'react-icons/io';
import { Formik } from 'formik';
import React from 'react';
import { FaFacebookSquare, FaInstagram, FaTwitterSquare, FaLinkedin } from 'react-icons/fa';

const Faqs = ({
	closeModal,	
	category,
	showCategory,
	faqData2,
	goBack
}) => {
	const callIcon = (
		<IoMdCall
			style={{
				color: 'var(--color-primary)',
			}}
		/>
	);

	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<div className={styles.cs}>
				<MimaText variant="subtitleBold" mb={4}>
					FAQs
				</MimaText>
				<img src={Support} className={styles.cs__img} />
				<MimaText variant="body" mb={2} mt={2}>
					See answers to frequently asked questions.
				</MimaText>
				{faqData2.map((faqItem, i) => (
					<div key={i}>
						<FlexButton
							title={faqItem.name}
							mb={2}
							variant="other"
							onClick={() => showCategory(i)}
						/>

						{category === i ? faqItem.faqs.map((faqContent, index) => (
							(<div className={styles.faq} key={index}>
								<MimaText variant="bodyBold" color="var(--color-primary)" mb={1}>{faqContent.question}</MimaText>
								<MimaText variant="small">{faqContent.answer}</MimaText>
								<div className={styles.faq__line} ></div>
							</div>)


						)) : ""}
					</div>
				))}
			</div>
			<div className={styles.cs}>
				<div className={styles.cs__menu}>

					<MimaText width={42} align="center" mt={2}>
						Reach out to us on any of our social media platforms by clicking below
					</MimaText>

					<div className={styles.cs__socials}>
						<a href="https://web.facebook.com/mimabusinessinc" target="_blank" rel="noreferrer">
							<FaFacebookSquare />
						</a>
						<a href="https://www.instagram.com/mimabusiness_hq/" target="_blank" rel="noreferrer">
							<FaInstagram />
						</a>
						<a href="https://twitter.com/MimaBusiness_Hq" target="_blank" rel="noreferrer">
							<FaTwitterSquare />
						</a>
						<a href="https://www.linkedin.com/company/trymima/" target="_blank" rel="noreferrer">
							<FaLinkedin />
						</a>
					</div>
				</div>
			</div>


		</Modal>
	);
};

export default Faqs;
